import Icon from '../components/Icon.vue'

Icon.register({
  question: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M202 0c84.9 0 175.5 66.3 175.5 153.6 0 116-125.3 117.8-125.3 160.6v5.8c0 13.3-10.7 24-24 24h-72.5c-13.3 0-24-10.7-24-24v-9.8c0-61.8 46.9-86.5 82.3-106.4 30.4-17 49-28.6 49-51.2 0-29.8-38.1-49.6-68.8-49.6-39.1 0-57.7 18.1-82.8 49.4-8.1 10.2-22.9 12-33.3 4.1l-43.1-32.7c-10.3-7.8-12.5-22.3-5.2-32.9 40.6-58.3 92.3-91 172.1-91zM192 373.5c38.2 0 69.3 31.1 69.3 69.3 0 38.2-31.1 69.3-69.3 69.3s-69.3-31.1-69.3-69.3c0-38.2 31.1-69.3 69.3-69.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/question.js
// module id = 1672
// module chunks = 0